import {
  type HistoryOptions,
  parseAsString,
  useQueryStates,
} from '@vrplatform/query-params';
import { removeDrawerStateFromUrl } from '../../utils';

type View = 'overview' | 'edit';

export function useReservationDetailDrawer() {
  const [opts, set] = useQueryStates({
    reservation: parseAsString,
    view: parseAsString,
  });

  // const invalidate = useInvalidateHasuraQueries();

  return {
    opened: !!opts.reservation,
    open: (
      id: string,
      view?: 'overview' | 'edit',
      updateType?: HistoryOptions
    ) => {
      removeDrawerStateFromUrl();
      set(
        { reservation: id, view: view || 'overview' },
        {
          history: updateType || 'push',
        }
      );
    },
    close: (updateType?: HistoryOptions) => {
      // invalidate(['reservations-table']);
      set(null, {
        history: updateType,
      });
    },
    reservationId: opts.reservation,
    view: (opts.view || 'overview') as View,
    setView: (view: View) => set({ view }),
  };
}
